import {KIconArchive} from '@/components/icons';
import {NotificationMessage} from '@/hooks/useGetNotifications';
import {IconButton} from '@mui/material';
import {useInbox} from '@trycourier/react-hooks';
import {FC} from 'react';
import {NotificationBadgeProps} from './types';

export type NotificationArchiveProps = NotificationBadgeProps;

/**
 * Notification show archive/unarchive and mark archive/unarchive
 */
export const NotificationArchive: FC<NotificationArchiveProps> = ({message, onChangeMessage}) => {
  const inbox = useInbox();

  /**
   * todo unarchive is not verified assuming just toggle behavior
   * as markMessageUnarchive is not defined.
   */
  const markArchived = async (message: NotificationMessage) => {
    await inbox.markMessageArchived(message.id);
    message.archived = true;
    onChangeMessage?.(message);
  };

  return message.archived ? (
    <IconButton
      color={'primary'}
      onClick={(event) => {
        event.stopPropagation();
        return markArchived(message);
      }}
      data-testid={`notification-${message.id}-mark-unarchived`}
      title={'Unarchive'}
    >
      <KIconArchive />
    </IconButton>
  ) : (
    <IconButton
      color={'primary'}
      onClick={(event) => {
        event.stopPropagation();
        return markArchived(message);
      }}
      data-testid={`notification-${message.id}-mark-archived`}
      title={'Archive'}
    >
      <KIconArchive />
    </IconButton>
  );
};
